module.exports = __webpack_public_path__ + "img/linkd2-4.94f12996.jpg";